import axios from 'axios';
import { useEffect, useState } from 'react';
import Player from './player/Player';
import imgLogoSG from '../assets/logoSG2.png';
// import Popup from './Popup';

function LiveChannel() {
	// const [showPopup, setShowPopup] = useState(false);
	const [linkPlay, setLinkPlay] = useState('');
	/** Get link play từ apiv2 hplus */
	const fetchLinkLive = () => {
		const dataPost = { id: '4009', device: 'stbox' };
		const headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
		};
		axios
			.post('https://apiv2.hplus.com.vn/detail/', dataPost, { headers })
			.then((response) => setLinkPlay(response.data.content.link))
			.catch((err) => {
				console.log('Err', err);
			});
	};

	useEffect(() => {
		fetchLinkLive();
	}, []);

	/** Get link play từ api detail seagame 
	const fetchLinkLive = () => {
		const dataPost = {};
		const headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
		};
		axios
			.post(
				'https://apiv2.hplus.com.vn/detail/get_link_seagame',
				dataPost,
				{ headers }
			)
			.then((response) => setLinkPlay(response.data))
			.catch((err) => {
				console.log('Err', err);
			});
	};

	useEffect(() => {
		fetchLinkLive();
	}, []);*/

	return (
		<div
			id="live"
			className="lg:mt-10 mt-5 lg:px-48 text-white lg:text-3xl text-3xl w-full scroll-mt-[100px]"
		>
			<div className="flex items-center gap-2">
				<span>
					<img src={imgLogoSG} alt="" width={32} />
				</span>
				<h2>TRUYỀN HÌNH TRỰC TIẾP</h2>
			</div>
			<div className="lg:flex h-full mt-5">
				<div className="lg:w-2/3 rounded-lg">
					{!linkPlay ? (
						<div>Loading...</div>
					) : (
						<div className="player rounded-l-lg overflow-hidden">
							<Player link={linkPlay} controls={true} />
						</div>
					)}
				</div>
				<div className="hidden lg:flex flex-col min-h-full rounded-r-lg bg-slate-600 w-1/3  items-center justify-center">
					<p className="mt-2 px-5 text-sm lg:text-4xl text-center">
						Kênh truyền hình trực tiếp SEA Games 33
					</p>
					{/* <div
						className='mt-3 cursor-pointer'
						onClick={() => setShowPopup(!showPopup)}
					>
						Xem lịch thi đấu
					</div> */}
				</div>
			</div>
			{/* <Popup isOpen={showPopup} onClose={() => setShowPopup(false)} /> */}
		</div>
	);
}

export default LiveChannel;
